define('modules/resolution/resolution.module',["client"],
    function(Prospector){
        Prospector.module("ResolutionApp", function(ResolutionApp, Prospector, Backbone, Marionette, $, _){
            ResolutionApp.startWithParent = false;

            ResolutionApp.onStart = function(){
                window.utils.rawOutput("starting ResolutionApp");
            };

            ResolutionApp.onStop = function(){
                window.utils.rawOutput("stopping ResolutionApp");
            };
        });

        Prospector.module("Routers.ResolutionApp", function(ResolutionAppRouter, Prospector, Backbone, Marionette, $, _){
            ResolutionAppRouter.Router = Marionette.AppRouter.extend({
                appRoutes: {
                    "resolve/person"             : "showResolvePerson" //added
                }
            });

            var API = {
                showResolvePerson: function(options) {
                    var func = $.proxy(function () {
                        require(["modules/resolution/main/resolution.controller"], function (ResolutionController) {
                            ResolutionController.loadResolvePerson(options);
                        });
                    }, this);
                    Prospector.trigger("authAcc", func);
                }
            };

            Prospector.addInitializer(function(){
                new ResolutionAppRouter.Router({
                    controller: API
                });
            });
        });
        return Prospector.ResolutionAppRouter;
    });
